var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProspectBeginner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 78,
    viewBox: "0 0 110 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA9E",
    d: "M0 35.434s18.793 2.124 29.176 12.74C31.773 46.403 110 0 110 0L0 35.434z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDE2CB",
    d: "M110 0L29 48.153 33.873 78l13.303-29.051z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC9A",
    d: "M46.91 49.014l11.39 3.758L82.81 62 110 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5616E",
    d: "M33.852 78.028L59 52.973l-11.893-3.89z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectBeginner);
export default __webpack_public_path__ + "static/media/prospect-beginner.5850cf177263030b055a5a9efac7a60c.svg";
export { ForwardRef as ReactComponent };